import { store } from '@atredux/store'
import {
    getSeawardIFrame,
} from '@atredux/selectors/iframeSelector'

import { CountMetric } from '@amzn/ihm-associate-tools-js-lib'
import { CrossFrameUtils } from '@amzn/jwo-store-management-platform-components'
import { ITool } from '@atredux/slices/toolSlice'
import { getSelectedLocale } from '@src/redux/selectors/localeSelector'

function getSeawardFrame (): Window | undefined {
    return getSeawardIFrame(store.getState())?.current?.contentWindow
}

export async function setZoneAndSubZone (zone, subZone) {
    const frame = getSeawardFrame()
    if (!frame) return
    console.info(`Setting zone / subzone in old seaward frame as ${JSON.stringify(zone)} / ${JSON.stringify(subZone)}`)
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'associateToolBaseSetZoneAndSubZone',
            data: {
                zone,
                subZone,
            },
        },
    })
}

export async function setTool (tool: ITool) {
    const frame = getSeawardFrame()
    if (!frame) return
    console.info('ATBase: Loading tool in old seaward frame: ' + JSON.stringify(tool))
    const toolName = tool.toolName
    const localeParam = store?.getState().locale ? getSelectedLocale(store.getState()) : 'en-US'

    let toolParams: {[key: string]: string} = {}
    if (tool.toolParameters) {
        toolParams = tool.toolParameters
    }
    toolParams.locale = localeParam
    const hashPath = tool.hashPath

    const seawardBasedToolMetrics = new CountMetric(undefined, toolName, 'IhmFlyingDutchman', 'ToolMenu.setTool')
    seawardBasedToolMetrics.count(1)
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'associateToolBaseSetTool',
            data: {
                tool: toolName,
                toolParams,
                hashPath,
            },
        },
    })
}

export async function pauseToolHeartbeat (switchingTool: boolean) {
    const frame = getSeawardFrame()
    if (!frame) return
    console.info('ATBase: Calling associateToolBasePauseToolHeartbeat event in old seaward frame')
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'associateToolBasePauseToolHeartbeat',
            data: { switchingTool },
        },
    })
}

export async function resumeToolHeartbeat () {
    const frame = getSeawardFrame()
    if (!frame) return
    console.info('ATBase: Calling associateToolBaseResumeToolHeartbeat event in old seaward frame')
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'associateToolBaseResumeToolHeartbeat',
            data: {},
        },
    })
}

export async function openNotificationModal () {
    const frame = getSeawardFrame()
    if (!frame) return
    console.info('ATBase: opening old seaward notification modal')
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'openNotificationModal',
            data: {},
        },
    })
}

export async function openInventoryViewerModal () {
    const frame = getSeawardFrame()
    if (!frame) return
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'openInventoryViewerModal',
            data: {},
        },
    })
}

export async function openProvideFeedbackModal () {
    const frame = getSeawardFrame()
    if (!frame) return
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'openProvideFeedbackModal',
            data: {},
        },
    })
}

export async function openViewFeedbackModal () {
    const frame = getSeawardFrame()
    if (!frame) return
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'openViewFeedbackModal',
            data: {},
        },
    })
}

export async function shouldShowZoneTasks () {
    const frame = getSeawardFrame()
    if (!frame) return
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'shouldShowZoneTasks',
            data: {},
        },
    })
}

export async function getZoneTaskCount () {
    const frame = getSeawardFrame()
    if (!frame) return
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'getZoneTaskCount',
            data: {},
        },
    })
}

export async function setZone (zoneInfo) {
    const frame = getSeawardFrame()
    if (!frame) return
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'setZoneInfo',
            data: {
                zoneInfo,
            },
        },
    })
}

export async function closeHeartBeatMenu () {
    const frame = getSeawardFrame()
    if (!frame) return
    console.info('ATBase: Calling associateToolBaseCloseToolHeartbeat crossFrame call')
    return CrossFrameUtils.sendMessageToOtherFrame({
        frame,
        message : {
            method: 'closeSeawardHeartBeatMenu',
            data: {},
        },
    })
}
